import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ConfirmationSlugEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { getCmsConfirmationContentAction } from "../../LogicActions/CmsConfirmationContent/GetCmsConfirmationContentAction";



export class ConfirmPopupAction extends BaseAction<void, boolean> {
    override async run(): Promise<void> {
        try {
            //updateRecoilState("cancelBookingConfirmPopupFlagAtom", this.params!);
            if (this.params === true) {
                const shouldOpen = this.params;
                setTimeout(() => {
                    updateRecoilState("cancelBookingConfirmPopupFlagAtom", shouldOpen);
                }, 500);

                getCmsConfirmationContentAction.setParams({ slug: ConfirmationSlugEnum.cancel_trip });
                getCmsConfirmationContentAction.execute();
            } else {
                updateRecoilState("cancelBookingConfirmPopupFlagAtom", this.params!);
            }

        } catch (error) {
            console.error("Error during cancel confirm popup action:", error);
        }
    }
}

export const confirmPopupAction = new ConfirmPopupAction();
